import { EncryptionsAccessLogClientTypeEntity } from '../entities';
import { authResource } from './Auth';
export const EncryptionsAccessLogClientTypeResource = authResource({
    path: '/encryptions/:encryptionId/accesslogs/clienttypes/:clientTypeId?',
    schema: EncryptionsAccessLogClientTypeEntity
});
